import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import adminRoutes from "routes/admin-routes";
import PageHeader from "./sections/PageHeader";
import MKBox from "components/MKBox";
import footerRoutes from "footer.routes";
import DefaultFooter from "components/DefaultFooter";
import ContainerCard from "components/ContainerCard";
import { UserDatabaseProvider } from "./contexts/UserDatabaseContext";
import UserDatabaseList from "./sections/UserDatabaseList";
import UserDatabaseControls from "./sections/UserDatabaseControls";
import Container from "@mui/material/Container";
import Breadcrumbs from "examples/Breadcrumbs";

function ChatsDatabase() {
  return (
    <>
      <DefaultNavbar routes={adminRoutes} />
      <PageHeader />
      <ContainerCard>
        <Container>
          <Breadcrumbs
            routes={[{ label: "Admin", route: "/admin" }, { label: "Gebruikers Database" }]}
          />

          <UserDatabaseProvider>
            <UserDatabaseControls />
            <UserDatabaseList />
          </UserDatabaseProvider>
        </Container>
      </ContainerCard>
      <MKBox pt={6} px={1} mt={6}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default ChatsDatabase;
